import * as C from 'constants/Redux'

const PREFIX = 'AUTH / '
const TOKEN = `${PREFIX}TOKEN`
const USER = `${PREFIX}USER`

export const HYDRATE_UNITE_SUCCESS = `${PREFIX}HYDRATE_UNITE_SUCCESS`
export const HYDRATE_UNITE_FAILURE = `${PREFIX}HYDRATE_UNITE_FAILURE`

export const TOKEN_UPDATE = TOKEN + C.UPDATE

export const USER_FETCH = USER + C.FETCH
export const USER_FETCH_PENDING = USER_FETCH + C.PENDING
export const USER_FETCH_FULFILLED = USER_FETCH + C.FULFILLED
export const USER_FETCH_REJECTED = USER_FETCH + C.REJECTED

export const ERROR = `${PREFIX}ERROR`

export const INITIAL_STATE = {
  loading: true,
  error: false,
  token: false,
  tokenType: 'JWT',
  accountId: false,
  userId: false,
}
